/** Real-time notification system (Phase 51) §26/§15 — per-browser
 * conveniences, deliberately not synced to the backend/DB: which viewer
 * wants desktop popups/sound is a device preference, not shared state.
 * Defaults are "professional and non-intrusive" per §15: popups on,
 * sound off. */
const POPUPS_KEY = 'imc.notifications.popupsEnabled';
const SOUND_KEY = 'imc.notifications.soundEnabled';

const readBool = (key: string, fallback: boolean): boolean => {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : raw === 'true';
  } catch {
    return fallback;
  }
};

const writeBool = (key: string, value: boolean): void => {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    // Private browsing / blocked storage — the toggle just won't persist
    // across reloads; the in-memory value for this session still applies.
  }
};

export const getPopupsEnabled = () => readBool(POPUPS_KEY, true);
export const setPopupsEnabled = (value: boolean) => writeBool(POPUPS_KEY, value);

export const getSoundEnabled = () => readBool(SOUND_KEY, false);
export const setSoundEnabled = (value: boolean) => writeBool(SOUND_KEY, value);
